export const resourceTypes = [
  'menu',
  'category',
  'item',
  'modifier-set',
  'modifier',
  'coupon',
] as const

export const SUPPORTED_BULK_EDIT_RESOURCE_TYPES = ['item', 'modifier'] as const

const bulkEditableResourceSet = new Set<string>(
  SUPPORTED_BULK_EDIT_RESOURCE_TYPES
)

export const isBulkEditableResource = (resourceType: string) =>
  bulkEditableResourceSet.has(resourceType)

export const resourceActions = ['clone', 'remove', 'toggleVisibility'] as const
export const resourceActionsSingle = ['remove', 'toggleVisibility'] as const
